import { render, staticRenderFns } from "./totalWaybill.vue?vue&type=template&id=2c2b3397&scoped=true"
import script from "./totalWaybill.vue?vue&type=script&lang=js"
export * from "./totalWaybill.vue?vue&type=script&lang=js"
import style0 from "./totalWaybill.vue?vue&type=style&index=0&id=2c2b3397&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2b3397",
  null
  
)

export default component.exports